import React, { useState } from "react";
import Header from "./components/header";
import Footer from "./components/footer"
import { LiveChatWidget } from '@livechat/widget-react'
import {Helmet} from "react-helmet"

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    services: [],
    honeypot: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "services") {
      setFormData((prevData) => ({
        ...prevData,
        services: prevData.services.includes(value)
          ? prevData.services.filter((service) => service !== value)
          : [...prevData.services, value],
      }));
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.honeypot !== "") {
      setStatus("Spam detected!");
      return;
    }

    const webhookUrl = "https://hooks.zapier.com/hooks/catch/19433399/2aw791n/"; // Replace with your webhook URL

    try {
      const response = await fetch(webhookUrl, {
        method: "POST",
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("Message sent successfully!");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          message: "",
          services: [],
          honeypot: "",
        });
      } else {
        setStatus("Failed to send message. Please try again.");
      }
    } catch (error) {
      setStatus("An error occurred. Please try again later.");
    }
  };

  const [visibility, setVisibility] = useState("minimized");

  return (
    <>
      <Helmet>
        <title>iFLO Pro | Contact Us</title>
        <meta name="description" content="Contact iFLO Pro and let us know how we can help you with your HVAC needs." />
        <meta name="keywords" content="iFLO Pro, HVAC, Contact Us" />
      </Helmet>
      <Header />
      <LiveChatWidget
        license="14746245"
        visibility={visibility}
      />
      <div className="h-full  bg-gradient-to-b from-gray-50 to-white text-gray-800 py-36 px-4">
        <div className="w-full max-w-screen-xl mx-auto">
          <div className="flex flex-col w-full md:flex-row gap-12">
            {/* Form Section */}
            <form
              onSubmit={handleSubmit}
              className="space-y-6 md:w-3/4 bg-white rounded-2xl "
            >
              <div className="space-y-2">
                <h2 className="text-4xl font-bold text-gray-900">Contact Our Team</h2>
                <p className="text-gray-600 text-lg">
                  Got any questions about the product or scaling on our platform?
                  We're here to help! Chat to our friendly team 24/7 and get
                  onboard in less than 5 minutes.
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">First name</label>
                  <input
                    type="text"
                    name="firstName"
                    placeholder="Enter your first name"
                    value={formData.firstName}
                    onChange={handleChange}
                    className="w-full p-4 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all"
                    required
                  />
                </div>
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Last name</label>
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Enter your last name"
                    value={formData.lastName}
                    onChange={handleChange}
                    className="w-full p-4 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all"
                    required
                  />
                </div>
              </div>
              <div className="space-y-2">
                <label className="text-sm font-medium text-gray-700">Email address</label>
                <input
                  type="email"
                  name="email"
                  placeholder="you@company.com"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full p-4 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all"
                  required
                />
              </div>
              <div className="space-y-2">
                <label className="text-sm font-medium text-gray-700">Phone number</label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="+1 (555) 000-0000"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full p-4 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all"
                  required
                />
              </div>
              <div className="space-y-2">
                <label className="text-sm font-medium text-gray-700">Message</label>
                <textarea
                  name="message"
                  placeholder="How can we help you?"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full p-4 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all h-32 resize-none"
                  required
                ></textarea>
              </div>

              <div className="space-y-4">
                <p className="font-semibold text-gray-900">How can we help you?</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {[
                    "Return/Refund",
                    "Payment processing questions",
                    "Order tracking",
                    "Product usage or features",
                    "Other",
                  ].map((service) => (
                    <label key={service} className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                      <input
                        type="checkbox"
                        name="services"
                        value={service}
                        checked={formData.services.includes(service)}
                        onChange={handleChange}
                        className="w-5 h-5 accent-yellow-500 rounded border-gray-300 focus:ring-yellow-500"
                      />
                      <span className="text-gray-700">{service}</span>
                    </label>
                  ))}
                </div>
              </div>

              <input
                type="text"
                name="honeypot"
                value={formData.honeypot}
                onChange={handleChange}
                className="hidden"
              />

              <button
                type="submit"
                className="w-full bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-4 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
              >
                Send message
              </button>
              {status && (
                <p className={`mt-4 text-sm ${status.includes("successfully") ? "text-green-600" : "text-red-600"}`}>
                  {status}
                </p>
              )}
            </form>

            {/* Contact Information Section */}
            <div className="md:w-1/3 w-full space-y-8 bg-white rounded-2xl  p-8">
              <div className="space-y-4">
                <h3 className="text-2xl font-bold text-gray-900">Chat with us</h3>
                <div className="space-y-3">
                  <button 
                    onClick={() => setVisibility("maximized")}
                    className="w-full text-left p-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors flex items-center space-x-3"
                  >
                    <span className="text-lg text-gray-700">Start a live chat</span>
                  </button>
                  <a 
                    href="mailto:HVACPros@iflo.com"
                    className="block w-full text-left p-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors"
                  >
                    <span className="text-lg text-gray-700">Shoot us an email</span>
                  </a>
                </div>
              </div>

              <div className="space-y-4">
                <h3 className="text-2xl font-bold text-gray-900">Call us</h3>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <p className="text-gray-700 space-y-2">
                    <span className="block font-medium">Monday - Friday: 8am-7pm</span>
                    <span className="block font-medium">Saturday: 10am-6pm</span>
                    <span className="block font-medium">Sunday: 10am-6pm</span>
                    <span className="block text-xl font-medium text-yellow-500 mt-2">+888-979-iFLO (4356)</span>
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                <h3 className="text-2xl font-bold text-gray-900">Our Office</h3>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <p className="text-gray-700">
                    <span className="block font-medium">Great Innovations, LLC</span>
                    <span className="block">2301 SW 145th Avenue</span>
                    <span className="block">Miramar, FL 33027</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
